export default class Connection {
  #type;
  #connectedTo;

  constructor(type, Entity) {
    this.#type = type;
    this.#connectedTo = Entity;
  }

  setType(type) {
    this.#type = type;
  }

  getType() {
    return this.#type;
  }

  setEntity(entity) {
    this.#connectedTo = entity;
  }

  getEntity() {
    return this.#connectedTo;
  }
}
